import {createStore} from '../utilities/storeUtils';
import  _ from 'underscore';
import {asnShippingPalletsKeyToArrayOfAsnhippingPallets} from './relationships';
import {isPresent, isGtZero} from '../utilities/general';
let asnShippingPallets = {};

const defaults = {
  asp_pallet_stackable : false
};

const AsnShippingPalletStore = createStore({
  storeEventBaseKey: "asn_shipping_pallet",
  normalizrKey: "asnShippingPallets",
  normalizr: asnShippingPalletsKeyToArrayOfAsnhippingPallets,
  getData(){
    return asnShippingPallets;
  },

  getAsnShippingPallets(ids){
    return _.chain(asnShippingPallets).pick(...ids).values().value();
  },
  
  getDefaults(){
    return defaults;
  },

  createFreightShippingPallet(data){
    data = _.extend({id: _.uuid()},  data);
    addAsnShippingPallate(data);
  },

  addAsnShippingPallate(data){
    return this.addObjectsAndEmit(asnShippingPallate, data);
  },

  update(id, newData){
    const detail = asnShippingPallate[id];
    asnShippingPallate[id] = {...detail, ...newData};
    
    this.emitEvent("change", detail);
    return this.emitObjectChange(asnShippingPallate[id]);
  },

  copyDimensionsToAllCasesForSameAsn(asnShippingPalletId){
    const asnShippingPallet = this.getAsnShippingPallet(asnShippingPalletId);
    const {asp_pallet_length, asp_pallet_width, asp_pallet_height, asp_pallet_weight, asp_pallet_stackable} = asnShippingPallet;
    let similarAsnShippingPallet = _(asnShippingPallets).pick(({asnId})=>{
      return asnShippingPallet.asnId === asnId;
    })
    
    $("input.asn-detail-length").val(asp_pallet_length);
    $("input.asn-detail-width").val(asp_pallet_width);
    $("input.asn-detail-height").val(asp_pallet_height);
    $("input.asn-detail-weight").val(asp_pallet_weight);
    if(asp_pallet_stackable){
       $(".stackable-pallet-checkbox").prop("checked", true);
    }else{
      $(".stackable-pallet-checkbox").prop("checked", false);
    }

    similarAsnShippingPallet = _(similarAsnShippingPallet).mapObject((curAsnShippingPallet)=>{
     
      return _.assign(curAsnShippingPallet, {asp_pallet_length, asp_pallet_width, asp_pallet_height, asp_pallet_weight, asp_pallet_stackable});
      
    });
    
    this.updateObjectsAndEmit(similarAsnShippingPallet);
  },

  getAsnShippingPallet(id){
    return asnShippingPallets[id];
  },

  getAllAsnShippingPallets(){
    return asnShippingPallets;
  },

  removeAllAsnShippingPallets(){
    let removeIds = _(asnShippingPallets).pluck("id");
    this.removeDataByIdsAndEmit(removeIds);
  },

  createNewAsnShippingPalletDetail(data){
    data = _.extend({id: _.uuid()},  data);
    return this.addAsnShippingPallet(data);
  },

addAsnShippingPallet(data){
    return this.addObjectsAndEmit(asnShippingPallets, data);
  }, 
haveDimensionsAndWeight(details){
    return _(details).all(this.hasDimensionsAndWeight, this);
  },
hasDimensionsAndWeight(detail){
    return (
      isGtZero(detail.asp_pallet_length) &&
      isGtZero(detail.asp_pallet_width) &&
      isGtZero(detail.asp_pallet_height) &&
      isGtZero(detail.asp_pallet_weight)
    );
  },

  organizeIntoPallets: organizeIntoFunc("id"),
  organizeIntoCases: organizeIntoFunc("id"),
  organizeIntoPalletsAndCases(details){
    return _.chain(this.organizeIntoPallets(details)).map((palletData)=>{
      return this.organizeIntoCases(palletData);
    }).value();
  },

});

function organizeIntoFunc(key){
  return (data)=>{
    return _.chain(data).values().groupBy((asnShippingPallet)=>{
      return asnShippingPallet[key];
    }).values().value();
  }
}

function setAttrForIdsFunc(groupKey){
  return function(ids, val){
    const out = _.chain(asnShippingPallets).pick(...ids).mapObject((asnShippingPallet, k)=>{
      asnShippingPallet[groupKey] = val;
      return asnShippingPallet;
    }).mapObject((asnShippingPallet, k)=>{
      this.emitObjectChange(asnShippingPallet);
    }).value();
    // emit a global change as well
    this.emitEvent('change', out);
    this.emitEvent(`changes:${groupKey}`, out);

    return out;
  }
}

function setAttrsForIds(ids, attrs={}){
  _(attrs).mapObject((v, k)=>{
    const func = setAttrForIdsFunc(k).bind(this);
    func(ids, v);
  });
}

window.AsnShippingPalletStore = AsnShippingPalletStore;
export default AsnShippingPalletStore;


// WEBPACK FOOTER //
// ./src/stores/AsnShippingPalletStore.js